import Repository from "./repository"

export default {
    /**
     * S20202_変更画面表示
     *
     * @param {object} params リクエストパラメータ
     */
    get(params) {
        return Repository.get('/api/s202-neo-contract-changes/view', { params: params })
    },
    /**
     * S20203_変更内容登録処理
     *
     * @param {object} params リクエストパラメータ
     */
    add(params) {
        return Repository.post('/api/s202-neo-contract-changes/add', params)
    }
}